export default {
  GET_GOAL_EARNINGS_QUERY: Symbol.for('GET_GOAL_EARNINGS_QUERY'),
  GOAL_EARNINGS_REPOSITORY: Symbol.for('GOAL_EARNINGS_REPOSITORY'),
};
